import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TypePerformancelevelComponent} from './type-performancelevel.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    TypePerformancelevelComponent,
  ],
  exports: [
    TypePerformancelevelComponent,
  ],
})
export class TypePerformancelevelModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-performancelevel/type-performancelevel.module.ts